import { Pipe, PipeTransform } from '@angular/core';
import { Asset, Holding } from '@ddt-web/domain';
import * as isNil from 'lodash/isNil';

import { JsonToAssetPipe } from './json-to-asset.pipe';

@Pipe({
	name: 'jsonToHolding'
})
export class JsonToHoldingPipe implements PipeTransform {
	private jsonToAssetPipe: JsonToAssetPipe = new JsonToAssetPipe();

	public transform(holdingJson: any, args?: any): any {
		const asset: Asset = this.jsonToAssetPipe.transform(holdingJson);
		let hasErrors = false;

		let weight: number = 0;
		if (!isNil(holdingJson?.weight)) {
			weight = holdingJson.weight;
		}

		let value: number = 0;
		if (!isNil(holdingJson?.value)) {
			value = holdingJson.value;
		}

		if (weight === 0 && value === 0) {
			hasErrors = true;
		}

		let subType: string = '';
		if (holdingJson?.subType) {
			subType = holdingJson.subType;
		} else {
			subType = '';
			hasErrors = true;
		}

		hasErrors = hasErrors || asset.isErroneous();

		return new Holding(asset, weight, value, subType, hasErrors);
	}
}
